// src/common/components/importFileUpload/ImportFileUpload.tsx
import React from 'react'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'
import classes from './ImportFileUpload.module.sass'
import { FaFileCode } from 'react-icons/fa'
import { useImportFileUpload } from './useImportFileUpload'

type Props = {
  file: File | null
  setFile: (file: File | null) => void
  extensions?: string[]
  maxCount?: number
}

export const ImportFileUpload = ({ file, setFile, extensions = ['json'], maxCount = 1 }: Props) => {
  const dark = useSelector(selectDarkTheme)

  const {
    drag,
    error,
    inputRef,
    onDropHandler,
    selectFiles,
    removeFile,
    dragStartHandler,
    dragLeaveHandler,
    dragOverHandler,
  } = useImportFileUpload({
    file,
    setFile,
    extensions,
    maxCount,
  })

  return (
    <div className={classes.DragContainer}>
      {!file ? (
        <div
          className={drag ? classes.DragZoneDrop : dark ? classes.DragZoneDark : classes.DragZone}
          onDragStart={dragStartHandler}
          onDragLeave={dragLeaveHandler}
          onDragOver={dragOverHandler}
          onDrop={onDropHandler}
        >
          <div className={classes.mainText}>
            Добавьте JSON-файл перетащив его в эту зону или кликом на кнопку
          </div>
          <label className={classes.DragLabel}>
            Выберите файл
            <input
              ref={inputRef}
              onChange={selectFiles}
              className={classes.DragInput}
              type="file"
              accept=".json"
            />
          </label>
        </div>
      ) : (
        <div className={dark ? classes.FileContainerDark : classes.FileContainer}>
          <div className={classes.FileInfo}>
            <FaFileCode size={48} className={classes.FileIcon} />
            <span className={classes.FileName}>{file.name}</span>
            <span className={classes.FileSize}>{(file.size / 1024).toFixed(1)} KB</span>
          </div>
          <div className={classes.FileActions}>
            <label className={classes.DragLabelSmall}>
              Заменить
              <input
                ref={inputRef}
                onChange={selectFiles}
                className={classes.DragInput}
                type="file"
                accept=".json"
              />
            </label>
            <span className={classes.DeleteButton} onClick={removeFile}>
              Удалить
            </span>
          </div>
        </div>
      )}
      <div className={classes.ErrorMessage}>{error}</div>
    </div>
  )
}
